(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:ChangePassword
   *
   * @description
   *
   */
  angular
  .module('neo.services')
  .factory('ChangePassword', ChangePassword);

  function ChangePassword($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/user/password');
  }
}());
